import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[konami]'
})
export class KonamiDirective {
  @Output() private konami: EventEmitter<void> = new EventEmitter<void>();

  private sequence: number[] = [];

  private konamiCode: number[] = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65];

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    this.sequence.push(event.keyCode);
    if (this.sequence.length > this.konamiCode.length) {
      this.sequence.shift();
    }
    const isCode = this.konamiCode.every((code: number, index: number) => code === this.sequence[index]);
    if (isCode) {
      this.konami.emit();
    }
  }

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/directives/konami.ts